import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { InfoCardComponent } from '../../shared/components/info-card/info-card.component';
import { ActionCardComponent, ActionCardData } from '../../shared/components/action-card/action-card.component';

/**
 * WHY: Final polterabend info page with flexible content projection
 * SOLID: Single responsibility - comprehensive polterabend information display
 */
@Component({
  selector: 'app-polterabend-final',
  templateUrl: './polterabend-final.html',
  imports: [CommonModule, RouterModule, InfoCardComponent, ActionCardComponent]
})
export class PolterabendFinalComponent {
  // WHY: Action cards data
  protected readonly actionCards = signal<ActionCardData[]>([
    {
      title: 'Fragen zum Polterabend?',
      description: 'Bei weiteren Fragen zum Polterabend könnt ihr euch gerne an uns wenden!',
      buttonText: 'Kontaktformular',
      routerLink: '/contact'
    },
    {
      title: 'Jetzt anmelden!',
      description: 'Seid dabei beim Polterabend! Bitte meldet euch bis zum 01. Juli 2026 zurück.',
      buttonText: 'Zur Anmeldung',
      routerLink: '/form'
    }
  ]);
}